import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import {
  faFileMagnifyingGlass,
  faTrashCan,
} from "@fortawesome/pro-light-svg-icons"
import { GetDocumentosComercialesImportadosByFiltersDtoProps } from "api/DTOs/GetDocumentosComercialesImportadosByFiltersDto"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"
import { OCRColoredNumber } from "../OCRColoredNumber"

export const OCR_COLUMNS = (
  t: TFunction,
  reviewDocument: (id?: string) => void,
  openDeleteModal: (id?: string) => void
) => {
  const columns = [
    {
      key: "razonSocial",
      header: `${t("importar.ocr.table.headerContainer")}`,
      field: "razonSocial",
    },
    {
      key: "numero",
      header: `${t("importar.ocr.table.headerNumFact")}`,
      field: "numero",
      sortable: true,
      sortField: "numero",
    },
    {
      key: "fechaEmision",
      header: `${t("importar.ocr.table.headerEmisionDate")}`,
      field: "fechaEmision",
      body: ({
        fechaEmision,
      }: GetDocumentosComercialesImportadosByFiltersDtoProps) =>
        fechaEmision ? frontendDateFormat(new Date(fechaEmision)) : "-",
      sortable: true,
      sortField: "fechaEmision",
    },
    {
      key: "importe",
      header: `${t("importar.ocr.table.headerImport")}`,
      field: "importe",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      body: (rowData: GetDocumentosComercialesImportadosByFiltersDtoProps) =>
        OCRColoredNumber({
          label: rowData?.importe
            ? `${frontendCurrency(rowData?.importe)}`
            : "-",
          type: rowData?.tipo,
        }),
      sortable: true,
      sortField: "importe",
    },
    {
      key: "opciones",
      style: { width: "4%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      alignCol: "right",
      body: (rowData: GetDocumentosComercialesImportadosByFiltersDtoProps) => {
        if (!rowData.id) return null

        return (
          <div className='tw-w-full tw-flex tw-justify-end [&_[id^="dropdown-menu-"]]:!-tw-top-5 [&_[id^="dropdown-menu-"]]:!tw-right-8'>
            <OptionsMenuStorybook
              id={rowData.id}
              items={[
                {
                  title: `${t("importar.ocr.table.reviewInvoice")}`,
                  hasRedirect: true,
                  action: () => {
                    reviewDocument(rowData?.id)
                  },
                  icon: faFileMagnifyingGlass,
                },
                {
                  title: `${t("importar.ocr.table.deleteInvoice")}`,
                  hasRedirect: true,
                  className: "!tw-text-danger",
                  action: () => openDeleteModal(rowData?.id),
                  icon: faTrashCan,
                },
              ]}
              position='right'
            />
          </div>
        )
      },
    },
  ]
  return columns
}
